import { toast } from 'react-toastify';

export const pathServer = {
  PATH_ICONS: `${process.env.PUBLIC_URL}/images/icons/`,
  PATH_IMG: `${process.env.PUBLIC_URL}/images/img/`,
};

export const typeResquest = {
  NEW: 'new',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
};

export const ACCEPT_REQUEST = 'approved';
export const DENIED_REQUEST = 'denied';
export const PENDING_REQUEST = 'pending';

export const STORAGE_TOKEN_COGNITO = 'idTokenCognito';
export const FIELD_NEXTTIME_LOGIN = 'nextTime';

export const REASSON_1 = 'El contratante no figura en el sistema como cliente.';
export const REASSON_2 =
  'El representante de la empresa contratante no reconoce al solicitante como personal de la empresa.';
export const REASSON_3 = 'El documento adjunto no corresponde a la Ficha RUC de la empresa.';

export const showSuccessToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const DOMAIN_READ_ONLY = 'protectasecuritygroup.com';

export const listOfProducts = {
  76: {
    icon: 'prdRentasVitalicias',
    name: 'Rentas Vitalicias',
  },

  74: {
    icon: 'prdDesgravamen',
    name: 'Desgravamen',
  },
  71: {
    icon: 'bag',
    name: 'Vida Individual',
  },
  73: {
    icon: 'prdVidaLey',
    name: 'Vida Ley',
  },

  77: {
    icon: 'prdSCTR',
    name: 'SCTR',
  },

  61: {
    icon: 'prdAccidentesP',
    name: 'Accidentes Personales',
  },
  66: { icon: 'prdSoat', name: 'SOAT' },

  75: {
    icon: 'prdRentaTotal',
    name: 'Renta Total Protecta',
  },

  752: {
    icon: 'prdAhorroTotal',
    name: 'Ahorro Total',
  },
  712: {
    icon: 'prdAhorroTotal',
    name: 'Ahorro Total Protecta',
  },
};

export const productsCode = {
  RENTA_VITALICIA: 'RRVV',
  RENTA_TOTAL: 'Rt',
  AHORRO_TOTAL: 'At',
  SOAT: 'SOAT',
};

export const LINE_BREAK_CODE = '\n';

export const productsTitle = {
  [productsCode.RENTA_VITALICIA]: 'Boletas',
  [productsCode.RENTA_TOTAL]: 'Liquidación de pago',
  [productsCode.AHORRO_TOTAL]: 'Liquidación de pago',
  [productsCode.SOAT]: 'Certificado Digital',
};

const optionsMenu = {
  news: {
    id: 11,
    title: 'Noticias',
    icon: 'construct',
    url: '/setting/news',
    options: [],
  },
  gallery: {
    id: 12,
    title: 'Galería',
    url: '/setting/gallery',
    icon: 'construct',
    options: [],
  },
  products: {
    id: 11,
    title: 'Productos',
    icon: 'construct',
    url: '/setting/products',
    options: [],
  },
  contact: {
    id: 14,
    title: 'Contactos',
    icon: 'construct',
    url: '/setting/contacts',
    options: [],
  },
};

export const menuSidebar = {
  1: [
    // transfor
    {
      id: 1,
      nameMenu: 'CONFIGURACIÓN GENERAL',
      menu: [optionsMenu.contact, optionsMenu.gallery, optionsMenu.news],
    },
  ],

  2: [
    // alvamedic
    {
      id: 1,
      nameMenu: 'CONFIGURACIÓN GENERAL',
      menu: [optionsMenu.contact, optionsMenu.products],
    },
  ],
  4: [
    // ankost
    {
      id: 1,
      nameMenu: 'CONFIGURACIÓN GENERAL',
      menu: [optionsMenu.contact, optionsMenu.gallery, optionsMenu.news],
    },
  ],
};

export const loginByOrg = {
  transfor: {
    img: 'transform.png',
    logo: 'orgTransfor',
  },
  alvamedic: {
    img: 'alvamedic.png',
    logo: 'orgAlvamedic',
  },
  ankost: {
    img: 'ankost.png',
    logo: 'orgAnkost',
  },
};

export const urlOrg = {
  1: {
    url: 'transfor',
    logo: 'transfor_logo.svg',
  },
  2: {
    url: 'alvamedic',
    logo: 'alvamedic_logo.png',
  },
  4: {
    url: 'ankost',
    logo: 'ankost_logo.svg',
  },
};
